import { ReactComponent as TableLogo } from 'shared/assets/icons/table.svg';
import { ReactComponent as ChartLogo } from 'shared/assets/icons/chart.svg';

export const TABLE = 'TABLE';
export const CHART = 'CHART';
export const SUN_BURST = 'SUN_BURST';
export const TREE_MAP = 'TREE_MAP';
export const ICICLE = 'ICICLE';
export const TIME_SERIES = 'TIME_SERIES';
export const HISTOGRAM = 'HISTOGRAM';
export const SANKEY = 'SANKEY';

export const DEFAULT_VIEW_OPTION_LIST = [
  {
    value: TABLE,
    icon: TableLogo,
  },
  {
    value: CHART,
    icon: ChartLogo,
  },
];

export const RESIZABLE_HANDLE_WIDTH = 4;
export const MIN_SEGMENT_WIDTH = 200 + RESIZABLE_HANDLE_WIDTH;
export const MIN_SEGMENT_HEIGHT = 200 + RESIZABLE_HANDLE_WIDTH;
